var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { tooltip as tooltipZIndex } from '@tencent/exeditor3-ui-kit/dist/zIndex.js';
import { generateEmojiStyles, generateEmojiStyle, } from './generateEmojiClass.js';
import { throttle } from '@tencent/exeditor3-core/dist/utils/throttle.js';
// popup距离浏览器的边界距离
const popupBoundary = 5;
const defaultNativeEmojiUrl = 'https://om.gtimg.cn/exeditor/emoji/nativeEmoji.json';
const fetchNativeEmoji = async (url) => {
    return fetch(url).then(async (res) => {
        return await res.json();
    });
};
let ExEditorEmojiPopupElement = class ExEditorEmojiPopupElement extends LitElement {
    constructor() {
        super(...arguments);
        this.nativeEmojiUrl = defaultNativeEmojiUrl;
        this.show = false;
        this.target = document.body;
        this.customEmoji = [];
        this.emojiTab = 'qq';
        this.nativeEmojiConfig = [];
        this.styleMap = {};
        this.localCacheKey = 'EXEDITOR_RECENT_EMOJI';
    }
    connectedCallback() {
        super.connectedCallback();
        // 需要把所有的style计算一遍
        this.customEmoji.forEach((emoji) => {
            this.styleMap[emoji.key] = generateEmojiStyles(emoji);
        });
        document.addEventListener('click', (e) => {
            if (!e.target) {
                return;
            }
            if (this.clickOut(e)) {
                if (this.show)
                    this.show = false;
            }
        });
        throttle(this.popupBoundaryCompute.bind(this), 100);
        window.addEventListener('resize', throttle(this.popupBoundaryCompute.bind(this), 100));
    }
    attributeChangedCallback(name, _old, value) {
        var _a;
        if (name === 'show' &&
            value !== null &&
            this.nativeEmojiConfig.length === 0) {
            fetchNativeEmoji((_a = this.nativeEmojiUrl) !== null && _a !== void 0 ? _a : defaultNativeEmojiUrl).then((emoji) => {
                this.nativeEmojiConfig = emoji;
            });
        }
    }
    render() {
        return html ` <div class="exeditor-emoji-triangle"></div>
      <div class="exeditor-emoji-popup">
        <div class="exeditor-emoji-popup-body">
          ${this.renderRecentEmoji()}
          <div class="title">全部</div>
          ${this.renderEmoji()}
        </div>
        <div class="exeditor-emoji-tab" @click="${this.tabClick}">
          <div
            tab="qq"
            class="exeditor-emoji-item${this.emojiTab === 'qq'
            ? ' exeditor-emoji-tab-select'
            : ''}"
          >
            <span style="${this.styleMap.qq[0]}"></span>
          </div>
          <div
            tab="native"
            class="exeditor-emoji-item${this.emojiTab === 'native'
            ? ' exeditor-emoji-tab-select'
            : ''}"
          >
            😄
          </div>
          ${this.customEmoji.slice(1).map((emoji) => {
            return html `
              <div
                tab="${emoji.key}"
                class="exeditor-emoji-item${this.emojiTab === emoji.key
                ? ' exeditor-emoji-tab-select'
                : ''}"
              >
                <span style="${this.styleMap[emoji.key][0]}"></span>
              </div>
            `;
        })}
        </div>
      </div>`;
    }
    renderEmoji() {
        if (this.emojiTab === 'native') {
            return html `
        <div class="exeditor-emoji" @click="${this.nativeEmojiClick}">
          ${this.nativeEmojiConfig.map((emoji) => {
                return html `<span class="exeditor-emoji-item">${emoji}</span>`;
            })}
        </div>
      `;
        }
        const currentEmoji = this.customEmoji.find((emoji) => emoji.key === this.emojiTab);
        if (currentEmoji) {
            const emojiStyles = this.styleMap[currentEmoji.key];
            return html `
        <div class="exeditor-emoji" @click="${this.customEmojiClick}">
          ${emojiStyles.map((style, index) => {
                return html `<span
              exeditor-emoji-index="${index}"
              class="exeditor-emoji-item"
            >
              <span style="${style}"></span>
            </span>`;
            })}
        </div>
      `;
        }
        return '';
    }
    renderRecentEmoji() {
        const recentUsed = this.getRecentEmoji();
        if (!recentUsed.length) {
            return '';
        }
        return html `
      <div class="exeditor-emoji-recent">
        <div class="title">最近使用</div>
        <div class="exeditor-emoji" @click="${this.recentClick}">
          ${recentUsed.reverse().map((item) => {
            if (item.key === 'native') {
                return html `<span
                exeditor-emoji-key="native"
                class="exeditor-emoji-item"
                >${item.value}</span
              >`;
            }
            const [idx, styles] = item.value.split('&&');
            return html `<span
              exeditor-emoji-key="${item.key}"
              exeditor-emoji-index="${idx}"
              class="exeditor-emoji-item"
            >
              <span style="${styles}"></span>
            </span>`;
        })}
        </div>
      </div>
    `;
    }
    recentClick(e) {
        e.stopPropagation();
        const key = this.getBubbleAttribute(e, 'exeditor-emoji-key');
        if (key === 'native') {
            return this.nativeEmojiClick(e, true);
        }
        this.customEmojiClick(e, true, key);
    }
    nativeEmojiClick(e, noCache = false) {
        e.stopPropagation();
        this.dispatchEmojiEvent('native', e.target.innerText);
        this.show = false;
        !noCache &&
            this.setRecentEmoji({ key: 'native', value: e.target.innerText });
    }
    customEmojiClick(e, noCache = false, key = this.emojiTab) {
        e.stopPropagation();
        const index = this.getBubbleAttribute(e, 'exeditor-emoji-index');
        const currentEmoji = this.customEmoji.find((emoji) => emoji.key === key);
        if (!currentEmoji) {
            return;
        }
        this.dispatchEmojiEvent(key, generateEmojiStyle(currentEmoji, Number(index), true));
        this.show = false;
        const styles = this.getBubbleAttribute(e, 'style');
        !noCache &&
            this.setRecentEmoji({ key, value: `${index}&&${styles}` });
    }
    dispatchEmojiEvent(key, value) {
        const event = new CustomEvent('exeditor-emoji-select', {
            detail: { key, value },
        });
        this.dispatchEvent(event);
    }
    tabClick(e) {
        e.stopPropagation();
        if (e.target.classList[0] === 'exeditor-emoji-tab') {
            return;
        }
        const tab = this.getBubbleAttribute(e, 'tab');
        this.emojiTab = tab;
    }
    clickOut(e) {
        const inNodeNames = ['EXEDITOR-ICON', 'EXEDITOR-EMOJI-POPUP'];
        return (!inNodeNames.includes(e.target.nodeName) ||
            (e.target.nodeName === inNodeNames[0] && e.target.name !== 'emoji'));
    }
    getBubbleAttribute(e, name) {
        var _a, _b, _c;
        return (e.target.getAttribute(name) ||
            ((_a = e.target.parentElement) === null || _a === void 0 ? void 0 : _a.getAttribute(name)) ||
            ((_c = (_b = e.target.children) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.getAttribute(name)) ||
            '');
    }
    getRecentEmoji() {
        try {
            return JSON.parse(localStorage.getItem(this.localCacheKey) || '[]').slice(-10);
        }
        catch (error) {
            return [];
        }
    }
    setRecentEmoji(emoji) {
        const recentUsed = this.getRecentEmoji();
        recentUsed.push(emoji);
        localStorage.setItem(this.localCacheKey, JSON.stringify(recentUsed));
    }
    popupBoundaryCompute() {
        var _a;
        const triangle = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.exeditor-emoji-triangle');
        const { left, right } = this.target.getBoundingClientRect();
        if (left < 210) {
            this.style.left = `-${left - popupBoundary}px`;
            triangle.style.left = `${left - popupBoundary + 10}px`;
        }
        else if (window.innerWidth - right < 210) {
            const x = window.innerWidth - right;
            this.style.left = `-${420 - x + popupBoundary}px`;
            triangle.style.left = `${430 - x + popupBoundary}px`;
        }
        else {
            this.style.left = '-210px';
            triangle.style.left = '220px';
        }
    }
};
ExEditorEmojiPopupElement.styles = [
    css `
      :host {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        position: absolute;
        width: fit-content;
        border: 1px solid #e7e7e7;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0 0 10px 0 rgb(0 0 0 / 6%);
        top: 35px;
        left: -210px;
        display: none;
        z-index: ${tooltipZIndex};
      }

      :host([show]) {
        display: block;
      }

      .exeditor-emoji-popup {
        position: relative;
        width: 433px;
        height: 328px;
        padding: 8px;
        z-index: 2;
        border-radius: 4px;
        overflow: hidden;
      }

      .exeditor-emoji-triangle {
        position: absolute;
        width: 10px;
        height: 10px;
        border: 1px solid #e7e7e7;
        border-right: 0;
        border-bottom: 0;
        top: -7px;
        left: 220px;
        background-color: #fff;
        transform: rotate(45deg);
        z-index: 1;
      }

      .exeditor-emoji-popup-body {
        width: 100%;
        height: 100%;
        overflow: auto;
        padding-bottom: 48px;
        box-sizing: border-box;
      }

      .exeditor-emoji-popup-body::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      .exeditor-emoji-popup-body::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #ccc;
      }

      .exeditor-emoji {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      .exeditor-emoji-item {
        width: 40px;
        height: 40px;
        padding: 8px;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 22px;
        line-height: 24px;
        text-align: center;
      }

      .exeditor-emoji-item:hover,
      .exeditor-emoji-tab-select {
        background: rgba(32, 35, 40, 0.08);
        cursor: pointer;
      }

      .exeditor-emoji-tab {
        width: 412px;
        height: 48px;
        display: flex;
        flex-direction: row;
        padding-top: 8px;
        border-top: 1px solid rgb(217, 219, 223);
        position: absolute;
        bottom: 0px;
        margin: 0 8px;
        background-color: #fff;
        z-index: 2;
      }

      .exeditor-emoji-recent {
        display: flex;
        flex-direction: column;
      }

      .exeditor-emoji-popup-body .title {
        color: rgb(160, 165, 174);
        font-size: 12px;
        font-weight: 400;
        padding: 8px;
        position: sticky;
        top: 0;
        background-color: #fff;
        text-align: left;
      }

      .exeditor-emoji-tab > div {
        margin-left: 10px;
      }

      .exeditor-emoji-tab > div:first-child {
        margin-left: 0px;
      }
    `,
];
__decorate([
    property({ type: String, reflect: true })
], ExEditorEmojiPopupElement.prototype, "nativeEmojiUrl", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ExEditorEmojiPopupElement.prototype, "show", void 0);
__decorate([
    property({ type: Element, reflect: false })
], ExEditorEmojiPopupElement.prototype, "target", void 0);
__decorate([
    property({ type: (Array), reflect: true })
], ExEditorEmojiPopupElement.prototype, "customEmoji", void 0);
__decorate([
    state()
], ExEditorEmojiPopupElement.prototype, "emojiTab", void 0);
__decorate([
    state()
], ExEditorEmojiPopupElement.prototype, "nativeEmojiConfig", void 0);
ExEditorEmojiPopupElement = __decorate([
    customElement('exeditor-emoji-popup')
], ExEditorEmojiPopupElement);
export { ExEditorEmojiPopupElement };
//# sourceMappingURL=emojiPopup.js.map